/* 布局 */
//前台
import Layout from "@views/layout";

const reservationtransportRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "reservationtransport/list",
            name: "RESERVATIONTRANSPORT",
            meta: {
                title: "遗体接运订单",
                keepAlive: true
            },
            component: () => import("@views/business/reservationtransport/index.vue"),
        },
    ],
};

export default reservationtransportRouter;
